<template>
    <v-layout>
    </v-layout>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'Forward',
  components: {},
  methods: {
  },
  data () {
    return {}
  },
  mounted () {
    if (this.$route.query.url) {
      this.$router.push(this.$route.query.url)
    }
    if (this.$route.params.url) {
      this.$router.push(this.$route.params.url)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Forward.vue